import { PaymentMethod } from '@dev/ee-api/ee-api-models';
import { Action } from 'redux';
export enum ActionTypes {
    UPDATE_PROVIDER_LIST = '@@payments/UPDATE_PROVIDER_LIST',
    LOAD_PROVIDER_LIST = '@@payments/LOAD_PROVIDER_LIST',
    PAYMENTS_ERROR = '@@payments/ERROR',
}

export interface LoadPaymentProvidersAction extends Action {
    type: ActionTypes.LOAD_PROVIDER_LIST;
}

export interface UpdateProviderListAction extends Action {
    type: ActionTypes.UPDATE_PROVIDER_LIST;
    payload: {
        providers: PaymentMethod[];
    };
}

export interface PaymentsErrorAction extends Action {
    type: ActionTypes.PAYMENTS_ERROR;
}
export interface PaymentsState {
    isLoading: boolean;
    providers?: PaymentMethod[];
}
